// extracted by mini-css-extract-plugin
module.exports = {"performances":"_96e1a1","performancesInner":"d28789"};